import { atom } from "recoil";      
import { ConfigJsonType } from "../model/configJsonType";
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist({
    key:'configJsonState',
    storage:sessionStorage,
});

export const configJsonState = atom<ConfigJsonType>({
    key: "configJsonState",
    default:{
        lang:'ja',
        isGachaMovie:'no',
        isTweetButton:'no',
        isGetNFTagainButton:'no',
        walletTypeArray:[`browserWallet`],
        insertTweetText:'',
        web3layerUrl:'',
        nftReceivingMovieUrl:'',
        nftReceivingImage:{
            url:'',
            isBlurred:true
        },
        isMyAppLink:true,
        backgroundImage:'',
    },
    effects_UNSTABLE:[persistAtom],
});